import { DateTime } from 'luxon';

class Address {
  name?: string;
  line1?: string;
  line2?: string;
  postal_code?: string;
  city?: string;
  state?: string;
  country?: string;

  constructor(data: Partial<Address> = {}) {
    Object.assign(this, data);
  }

  edit = (data: Partial<Address>) => {
    Object.keys(data).forEach((key) => {
      if (key in this) {
        this[key] = data[key];
      } else {
        console.error(`Address: Unknown key ${key}`);
      }
    });
  };

  toData = () => {
    return {
      name: this.name,
      line1: this.line1,
      line2: this.line2,
      postal_code: this.postal_code,
      city: this.city,
      state: this.state,
      country: this.country,
    };
  };
}

export default class Billing {
  name?: string = '';
  cardToken?: string = '';
  address: Address;
  brand?: string;
  expMonth?: number;
  expYear?: number;
  last4?: string;
  cost?: number;
  currency?: string;
  planAmountSessions?: number;
  planAmountRuns?: number;
  nextBillingDate?: DateTime | null;

  constructor(data: Partial<Billing> = {}) {
    Object.assign(this, data);
    // the API sends epoch ms; it becomes a DateTime here
    this.nextBillingDate = data.nextBillingDate
      ? DateTime.fromMillis(data.nextBillingDate as unknown as number)
      : null;
    this.address = data.address ? new Address(data.address) : new Address();
  }

  edit = (data: Partial<Billing>) => {
    Object.keys(data).forEach((key) => {
      if (key in this) {
        this[key] = data[key];
      } else {
        console.error(`Billing: Unknown key ${key}`);
      }
    });
    return this;
  };

  toData = () => {
    return {
      cardToken: this.cardToken,
      name: this.name,
      address: this.address.toData(),
      brand: this.brand,
      expMonth: this.expMonth,
      expYear: this.expYear,
    };
  };
}
